import React, { useEffect, useState } from "react";
import Cars from "./Cars";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import {
  emptyInvoice,
  removeDepositPremiumCheck,
  removeExcessInsurance,
  removefullDepositCheck,
} from "../../../utils/invoice/invoiceSlice";
import { clearUser } from "../../../utils/userSlices/userSlice";
import { emptyExtraArr, removeExtra } from "../../../utils/extraSlice";
import { switchOffLoader } from "../../../utils/loaderSlice";
import { TbMoodSad } from "react-icons/tb";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import { baseUrl } from "../../../config";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function SearchResultsCar() {
  const dispatch = useDispatch();
  const [carList, setCarList] = useState([]);
  const [sortCarList, setSortCarList] = useState([]);
  const [carNameFilterList, setCarNameFilterList] = useState([]);
  const [filteredListByCarName, setFilteredListByCarName] = useState([]);
  const [valueCheck, setValueCheck] = useState(0);
  const [carFilterText, setCarFilterText] = useState("");
  const totalDays = useSelector(
    (store) => store.bookingInfoSlice.totalNumberOfDays
  );

  const [arrayOfCars, setArrayOfCars] = useState([]);

  useEffect(() => {
    let arr = ["01C", "03E", "05E", "02P"];
    for (let i = 0; i < arr.length; i++) {
      dispatch(removeExtra(arr[i]));
    }
    dispatch(removefullDepositCheck());
    dispatch(removeDepositPremiumCheck());
    dispatch(removeExcessInsurance());
  }, []);

  useEffect(() => {
    if (carFilterText && carNameFilterList.length) {
      const filtered = carNameFilterList.filter((item, index) => {
        return carNameFilterList[index].imageName
          .toLowerCase()
          .includes(carFilterText.toLowerCase());
      });
      setFilteredListByCarName(filtered);
    }
  }, [carFilterText, carNameFilterList.length]);

  useEffect(() => {
    dispatch(emptyInvoice());
    dispatch(clearUser());
    dispatch(emptyExtraArr());
  }, []);

  useEffect(() => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${baseUrl}/app/v1/vehicles/getSelfVehicles/` + totalDays,
    };

    try {
      axios
        .request(config)
        .then((response) => {
          let newArr = [];
          for (let i = 0; i < response.data.result.length; i++) {
            if (response.data.result[i].onDemand) {
              const newObj = { ...response.data.result[i] };

              // Override the type property with the new value "hot sellers"
              newObj.type = "Top Sellers";

              // Push the new object to newArr
              newArr.push(newObj);
            }
          }
          for (let i = 0; i < response.data.result.length; i++) {
            if (!response.data.result[i].onDemand) {
              newArr.push(response.data.result[i]);
            }
          }

          setCarList(newArr);

          // setCarList(response.data.result);
          setCarNameFilterList(response.data.result);
          setSortCarList(response.data.result);
          dispatch(switchOffLoader());
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {}
  }, [totalDays]);
  useEffect(() => {
    const uniqueNames = [...new Set(carList.map((item) => item.type))];
    setArrayOfCars(uniqueNames);
  }, [carList]);

  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleCarSortList = (val) => {
    function getFirstPayNowValue(car) {
      for (const key in car.payNowPrice) {
        if (car.payNowPrice.hasOwnProperty(key)) {
          return car.payNowPrice[key];
        }
      }
    }

    let newArray = sortCarList.sort((a, b) => {
      const firstValueA = getFirstPayNowValue(a);
      const firstValueB = getFirstPayNowValue(b);
      if (val) {
        return firstValueA - firstValueB;
      } else {
        return firstValueB - firstValueA;
      }
    });
    setSortCarList(newArray);
  };

  const handleSorting = (e) => {
    handleCarSortList(e.target.value == 0 ? true : false);
    setValueCheck(valueCheck + 1);
  };

  const handleSortCanceling = () => {
    setValueCheck(0);
  };
  return (
    <>
      <div className="bg-white px-[10.27%] py-[2%] ">
        <div className="flex items-center justify-between pb-4">
          <div className="text-[#555555] block max-sm:hidden">
            <span className="border-r border-black pr-6">Self Drive Cars</span>
            <span className="font-bold text-black pl-6">Search Results</span> (
            {carList.length} vehicles available)
          </div>
          <div className="text-[#555555] hidden max-sm:block">
            <span className="font-bold text-black">Self Drive Cars</span>
            <br />
            <span className="font-bold text-black text-xs">
              Search Results
            </span>{" "}
            <br />{" "}
            <span className="text-xs">
              ({carList.length} vehicles available)
            </span>
          </div>
          <div className="flex max-sm:block">
            {/* <Tooltip title={sorting ? "Low to High" : "High to Low"}>
              <IconButton onClick={handleSorting}>
                <SortIcon
                  className={`${sorting ? "rotate-180" : "rotate-0"}`}
                />
              </IconButton>
            </Tooltip> */}
            <div className="flex items-center justify-end ">
              <label htmlFor="sorting" className="text-sm mr-2 max-sm:hidden">
                Sorting:{" "}
              </label>
              <select
                name="sorting"
                id="sorting"
                onChange={handleSorting}
                className="text-sm outline outline-[1px] rounded px-2 py-1 max-sm:w-[80%]"
              >
                <option value="" disabled selected>
                  Sort By Price
                </option>
                <option value="0">Price - Low to High</option>
                <option value="1">Price - High to Low</option>
              </select>
            </div>

            <div className="max-sm:flex max-sm:justify-end">
              <Tooltip title="Remove Sorting">
                <IconButton onClick={handleSortCanceling}>
                  <FilterListOffIcon />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </div>
        <div className="h-full w-full items-center justify-center my-2">
          <label
            htmlFor="carName filter"
            className="text-[16px] mr-2 font-poppins"
          >
            Search By Car Name:{" "}
          </label>
          <input
            type="text"
            placeholder="Car Name"
            className="h-[28px] border border-black outline-none pl-2 text-sm rounded px-2 py-4"
            value={carFilterText}
            onChange={(event) => setCarFilterText(event.target.value)}
          />
        </div>
        {!carFilterText ? (
          <>
            {valueCheck > 0 ? (
              <div className="grid grid-cols-2 gap-x-5 gap-y-6 pt-4 max-sm:grid-cols-1 max-sm:pt-2">
                {sortCarList.map((e, index) => (
                  <div key={index}>
                    <Cars
                      sorted={true}
                      handleClick={handleClick}
                      carDetails={e}
                    />
                  </div>
                ))}
              </div>
            ) : (
              arrayOfCars.map((carCategory, index) => (
                <>
                  {carList.filter((vehicle) => vehicle.type === carCategory)
                    .length != 0 ? (
                    <div key={index} className="mt-10 mb-10">
                      <div
                        key={index}
                        className="underline underline-offset-4 decoration-[#555555] text-black pb-2 font-bold text-lg"
                      >
                        {carCategory}
                      </div>

                      <div className="grid grid-cols-2 gap-x-5 gap-y-6 pt-4 max-sm:grid-cols-1 max-sm:pt-2">
                        {carList
                          .filter((vehicle) => vehicle.type === carCategory)
                          .map((e, index) => (
                            <div key={index}>
                              <Cars
                                sorted={false}
                                handleClick={handleClick}
                                carDetails={e}
                              />
                            </div>
                          ))}
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </>
              ))
            )}
          </>
        ) : (
          <>
            {filteredListByCarName.length > 0 ? (
              <div className="grid grid-cols-2 gap-x-5 gap-y-6 pt-4 max-sm:grid-cols-1 max-sm:pt-2">
                {filteredListByCarName.map((e, index) => (
                  <div key={index}>
                    <Cars
                      sorted={false}
                      handleClick={handleClick}
                      carDetails={e}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-black my-8 border text-center py-2 rounded-md">
                <TbMoodSad className="w-full text-[4rem] text-[#949292]" />{" "}
                Sorry! No Cars Available for this search
              </div>
            )}
          </>
        )}
      </div>

      <Stack spacing={2} sx={{ width: "100%", color: "white" }}>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity="info"
            sx={{ width: "100%", color: "white" }}
          >
            Currently Unavailable!
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default SearchResultsCar;
